import { useAntTheme } from "hooks/useAntTheme/";

export const ColorPreviewBlock = ({
  color,
  size = 60,
}: {
  color: string;
  size?: number;
}) => {
  const { theme } = useAntTheme();
  const borderRadius = size / 6;
  return (
    <div
      data-testid="color-preview-block"
      style={{
        width: size,
        height: size,
        borderRadius: borderRadius,
        backgroundColor: color,
        border: `1px solid ${theme.colorBorder}`,
        flexShrink: 0,
      }}
    />
  );
};
